module.exports = __webpack_public_path__ + "static/media/reload_captcha.19e9dd2b.webp";